function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { cloneElement } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import Slide from '@material-ui/core/Slide';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { CrossIcon } from '../icons';
import { closeModal } from './actions';
const transition = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(Slide, _extends({
  direction: "up",
  ref: ref
}, props)));
const StyledDialog = withStyles({
  paper: {
    borderRadius: '16px',
    overflow: 'hidden',
    boxShadow: '0 20px 60px rgba(0,0,0,0.14), 0 8px 24px rgba(0,0,0,0.08)'
  }
})(Dialog);
const StyledDialogContent = withStyles({
  root: {
    padding: '24px',
    '&:first-child': {
      paddingTop: '24px'
    }
  }
})(DialogContent);
const modalHeaderStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  padding: '18px 20px 16px 24px',
  borderBottom: '1px solid #f0f0f0',
  background: 'linear-gradient(to bottom, #fff5f5, #ffffff)',
  borderTop: '4px solid #E6616A'
};
const closeBtnStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  width: 32,
  height: 32,
  border: 'none',
  borderRadius: '50%',
  background: 'transparent',
  cursor: 'pointer',
  color: '#6b7280',
  flexShrink: 0,
  transition: 'background 0.15s, color 0.15s'
};
const Modal = ({
  id,
  title,
  children,
  noCloseIcon = false,
  maxWidth = 'md',
  showTitle = true,
  className,
  titleClassName
}) => {
  const dispatch = useDispatch();
  const {
    data
  } = useSelector(state => state.modal);
  const modalData = data?.find(modal => modal.id === id);
  if (!modalData) {
    return null;
  }
  const {
    maxWidth: oMaxWidth,
    ...childProps
  } = modalData.options || {};
  const onClose = () => dispatch(closeModal(id));
  return /*#__PURE__*/React.createElement(StyledDialog, {
    id: id,
    fullWidth: true,
    maxWidth: oMaxWidth || maxWidth,
    open: !!modalData,
    TransitionComponent: transition,
    onClose: onClose
  }, showTitle && /*#__PURE__*/React.createElement("div", {
    style: modalHeaderStyle,
    className: titleClassName
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: '17px',
      fontWeight: 600,
      color: '#1f2937',
      letterSpacing: '-0.01em'
    }
  }, modalData.title || title), !noCloseIcon && /*#__PURE__*/React.createElement("button", {
    type: "button",
    style: closeBtnStyle,
    onClick: onClose,
    onMouseEnter: e => {
      e.currentTarget.style.background = '#f3f4f6';
      e.currentTarget.style.color = '#111827';
    },
    onMouseLeave: e => {
      e.currentTarget.style.background = 'transparent';
      e.currentTarget.style.color = '#6b7280';
    }
  }, /*#__PURE__*/React.createElement(CrossIcon, {
    style: {
      fontSize: 20
    }
  }))), /*#__PURE__*/React.createElement(StyledDialogContent, {
    className: className
  }, modalData && /*#__PURE__*/cloneElement(children, childProps)));
};
Modal.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string,
  children: PropTypes.any,
  variant: PropTypes.string
};
export default Modal;